// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostPDFRequestModel from '../../model/post-pdf-request-model';
import PostPDFRequestDTO from '../dto/post-pdf-request-dto';
import dtoSchema from '../schemas/post-pdf-request-schema';
import Tdg_TourItemModel from '../../model/tdg-tour-item-model';

export default abstract class PostPDFRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostPDFRequestDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_TourItemModel.toModel(i)) ?? [];
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  */
  items?: Tdg_TourItemModel[];
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<PostPDFRequestDTO>): PostPDFRequestModel;
  static toModel(dto: DeepPartial<PostPDFRequestDTO> | undefined | null): PostPDFRequestModel | undefined;
  static toModel(dto: DeepPartial<PostPDFRequestDTO> | undefined | null): PostPDFRequestModel | undefined {
    return dto ? new PostPDFRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostPDFRequestModel> | PostPDFRequestModel): PostPDFRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      eventIdentifier: unwrapped.eventIdentifier,
    } as PostPDFRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostPDFRequestModel, can not map to PostPDFRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
